import { useEffect } from "react";

import { setMapboxAvailable, setOnline } from "../appSlice";

import { useAppDispatch } from "@/app/hooks";
import { INTERNET_CONNECTION_CHECK_URL } from "@/constants";
import { ping } from "@/features/utils/utils";

const useOnlineDetector = () => {
  const dispatch = useAppDispatch();

  const testConnection = () => {
    ping(
      INTERNET_CONNECTION_CHECK_URL,
      () => {
        dispatch(setOnline(true));
        dispatch(setMapboxAvailable(true));
      },
      () => {
        dispatch(setOnline(false));
      },
    );
  };

  useEffect(() => {
    // Test on first load
    testConnection();

    window.addEventListener("online", testConnection);
    window.addEventListener("offline", testConnection);

    // Remove listener
    return () => {
      window.removeEventListener("online", testConnection);
      window.removeEventListener("offline", testConnection);
    };
  }, []);
};

export default useOnlineDetector;
